import { DefaultActions, Separator, Showing, Total, Search, Wrapper } from '@/components/Grid/components/header/Heading';
import { DefaultGrid, GridProvider, GridTableSortable, useBuildGrid } from '@Components/Grid';

import { useRetargetingStore } from '../../store';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'

function RetargetingGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    events: useEvents(),
  })

  return <DefaultGrid
    heading={<Wrapper>
      <Search />
      <Separator />
      <Total />
      <Showing />
      <Separator />
      <DefaultActions />
    </Wrapper>}
    filters={null}
    table={<GridTableSortable />}
  />
}

export default function RetargetingGridLayout() {
  return <GridProvider store={useRetargetingStore()}>
    <RetargetingGrid />
  </GridProvider>
}
